module.exports = __webpack_public_path__ + "static/img/city-red-ar.d0624d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/red-about/city-red-ar.png
// module id = 1062
// module chunks = 173